// API-Utility-Funktionen
export async function apiCall(endpoint, options = {}) {
	try {
		const response = await fetch(endpoint, {
			method: options.method || 'POST',
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
				...options.headers
			},
			body: options.body
		});

		if (!response.ok) {
			throw new Error(`HTTP error! status: ${response.status}`);
		}

		return await response.json();
	} catch (error) {
		console.warn(`API-Call fehlgeschlagen (${endpoint}):`, error);
		throw error;
	}
}
